"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _deprecate = _interopRequireDefault(require("../../utils/deprecate"));
(0, _deprecate.default)({
  name: 'Loader',
  newName: 'Loader',
  changes: ['---- Changes in v2 component  ----', '`borderWidth` is now `thickness`', '`additionalMarkup` is no longer supported within this component', '`className` is no longer explicitly supported, but a custom class could still be passed in if needed, but with the move to ChakraUI custom classes are generally not needed', '---- Additional Information ----', 'new props are documented at: https://chakra-ui.com/docs/feedback/circular-progress']
});
const Loader = ({
  className,
  size,
  borderWidth,
  additionalMarkup,
  ...attrs
}) => {
  const classes = (0, _classnames.default)('Loader', className);
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: classes
  }, attrs), /*#__PURE__*/_react.default.createElement("div", {
    className: "Loader-spinner",
    style: {
      width: size,
      height: size,
      borderWidth
    }
  }), additionalMarkup);
};
Loader.defaultProps = {
  size: 80,
  borderWidth: 4
};
var _default = exports.default = Loader;